import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "seq-otp",
  ref: "root"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.digits, (digit, index) => {
      return (_openBlock(), _createBlock("input", {
        key: index,
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        maxlength: "1",
        class: "seq-otp__box",
        value: digit,
        disabled: _ctx.disabled,
        onInput: ($event: any) => (_ctx.onInput(index, $event)),
        onKeydown: ($event: any) => (_ctx.onKeydown(index, $event)),
        onPaste: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectOnFocus && _ctx.selectOnFocus(...args)))
      }, null, 40, ["value", "disabled", "onInput", "onKeydown"]))
    }), 128))
  ], 512))
}